import { Component, OnInit, NgModule} from '@angular/core';
import { ReactiveFormsModule, FormsModule,FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';


// @NgModule({
//   imports: [
//        ReactiveFormsModule,
//        FormsModule,
//        FormControl

//   ]})

@Component({
  selector: 'app-select-groups',
  templateUrl: './select-groups.component.html',
  styleUrls: ['./select-groups.component.scss']
})
export class SelectGroupsComponent implements OnInit {

  existingGroupArray =[];
  existingGroupArrayRefine =[];
  optselected: boolean = false;
  groupSelection:string;
  newGroupName:string;
  createGroup: FormControl;
  createGroupFlag:boolean = false;
  existingFlag:boolean = false;
  selectedFan: any;
  // public groupPattern = /^[^\s]+[a-zA-Z0-9\s]{0,5}$/;
  // public groupPattern = /^[^\s]+[a-zA-Z0-9\s]+$/;
  public groupPattern = /^(?! )[a-zA-Z0-9\s]+$/;


  public isGroupEmpty: boolean;
  public isGroupInvalid: boolean;



  

  constructor(private router: Router,private stepIndicatorService: StepIndicatorService,private route: ActivatedRoute,
    private chips: ChipsService,
    ) { }

  ngOnInit(): void {

    // this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    // this.stepIndicatorService.setVisibility(true);

    this.selectedFan = sessionStorage.getItem("selectedFAN");
    this.chips.setChips([{
      "label": "Home",
      "routerLink": "/home"
    }, {
      "label": "Manage Accounts",
      "routerLink": "/manageInventory"
    }, {
      "label": 'Devices for foundation account   ' + this.selectedFan,
      "routerLink": "manageInventory/deviceInventory"
    }, {
      "label": "Group Devices",
      "routerLink": "/groupingDevices/selectGroup"
    }]);

    let fanGroups = JSON.parse(sessionStorage.getItem('fanGroups'));
    this.existingGroupArray = [];
    
    if(fanGroups){
      this.existingGroupArray = fanGroups.filter(x=>x.name !== 'Select' && x.name.toLowerCase() !== ('default group').toLowerCase()).map(x=>x.name)
    }

    this.existingGroupArrayRefine = this.existingGroupArray.sort().map(x=>x.toLowerCase())
    
    this.createGroupFlag = JSON.parse(sessionStorage.getItem('createGroupFlag'));
    this.groupSelection =  'Default Group';
    if(sessionStorage.getItem('groupSelection')){
    this.groupSelection = sessionStorage.getItem('groupSelection');
    }

    if(this.groupSelection === 'Default Group'){
      // this.groupSelection ='';
      this.createGroupFlag = false;
    }

    if(!this.groupSelection){
      this.groupSelection = 'Default Group'
    }


    this.createGroup = new FormControl();

  }

  groupSelected(event) { 
    // this.groupSelection = "";
    this.optselected = false;
    this.createGroupFlag = false;

    if (event.target.value) {
      if(event.target.value ==="Create a new group"){
        this.optselected = false;
        this.groupSelection = "";
        sessionStorage.setItem("groupSelection", this.groupSelection);
        this.createGroupFlag =true;
        sessionStorage.setItem("createGroupFlag", (this.createGroupFlag).toString());


      }else {
        this.optselected = true;
        this.groupSelection = event.target.value;
        this.existingFlag = false;
        sessionStorage.setItem("groupSelection", this.groupSelection);
        this.createGroupFlag =false;
        sessionStorage.setItem("createGroupFlag", (this.createGroupFlag).toString());
      }
    }
  }

  newGroupCreation(value){

    if((this.existingGroupArrayRefine.indexOf(this.groupSelection.toLowerCase())>-1 || this.groupSelection.toLowerCase() === 'default group')&& this.createGroupFlag){
      // this.existingFlag = true;
    }else{
      this.existingFlag = false;
    }

    if (value == '') {
      this.isGroupEmpty = true;
      this.isGroupInvalid = false;

      this.optselected = false;
      this.groupSelection = "";
      sessionStorage.setItem("groupSelection", this.groupSelection);
    }
    else if (this.groupPattern.test(value) && value && value.length<=30) {

      this.isGroupEmpty = false;
      this.isGroupInvalid = false;

      this.optselected = true;
      this.groupSelection = value;
      sessionStorage.setItem("groupSelection", this.groupSelection);
    }
    else {
      this.isGroupEmpty = false;
      this.isGroupInvalid = true;

      this.optselected = true;
      this.groupSelection = value;
      sessionStorage.setItem("groupSelection", this.groupSelection);
    }

  }

  continue(){

    if(this.groupSelection.endsWith(' ')){
      this.groupSelection = this.groupSelection.trim();
    }

    

    if((this.existingGroupArrayRefine.indexOf(this.groupSelection.toLowerCase())>-1 || this.groupSelection.toLowerCase() === 'default group')&& this.createGroupFlag){
      this.existingFlag = true;
    }else if(!this.isGroupInvalid){
      sessionStorage.setItem("groupSelection", this.groupSelection);
      this.router.navigate(['/groupingDevices/review']);
    }
  
  }

  clickBack(){
    this.stepIndicatorService.setCurrentStep("selectDevices");
    this.stepIndicatorService.setVisibility(true);
    setTimeout(() => {
      this.router.navigate(['/groupingDevices/selectDevices']);
      sessionStorage.setItem('callingURL', '/groupingDevices/selectGroup');
    }, 500)
    
  }

  clickCancel(){
    sessionStorage.removeItem('groupSelection');
    sessionStorage.removeItem('createGroupFlag');
    this.router.navigate(['/manageInventory/deviceInventory']);
  }

}